import { useElementSize } from "@vueuse/core";

const bottomBarRef = ref<HTMLElement | null>(null);
const { height: bottomBarHeight } = useElementSize(bottomBarRef, { width: 0, height: 0 }, {
  box: 'border-box',
});

export function useBottomBarSize() {
  return {
    bottomBarRef,
    bottomBarHeight,
  };
}
